import { render, staticRenderFns } from "./CadPagamentoExtra.vue?vue&type=template&id=02866372&"
import script from "./CadPagamentoExtra.vue?vue&type=script&lang=js&"
export * from "./CadPagamentoExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports